export default "__VITE_ASSET__BZTu8yIM__"